import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $('#classification-location-search').on('submit', function(e){
      e.preventDefault()
      let locationId = $('#location_id').val()
      let classificationId = $('#classification_id').val()
      
      let url = `/direktori/${locationId}/sewa/${classificationId}`

      Turbolinks.visit(url, { action: 'replace' })
    });

    $('#locations-autocomplete').easyAutocomplete({
      getValue: 'name',
      url: function(query) {
        return `/direktori/locations_autocomplete?phrase=${query}&format=json`;
      },
      listLocation: 'districts',
      requestDelay: 500,
      matchResponseProperty: 'input_phrase',
      adjustWidth: false,
      categories: [ 
        {   
          listLocation: "regencies",
          header: "-- Kota / Kabupaten --",
          maxNumberOfElements: 10,
        },
        {   
          listLocation: "districts",
          header: "-- Kecamatan --",
          maxNumberOfElements: 10,
        },
      ],
      list: {
        maxNumberOfElements: 20,
        onChooseEvent: function() {
          let locationSlug = $('#locations-autocomplete').getSelectedItemData().slug
          let locationIdElem = $('#location_id')

          locationIdElem.val(locationSlug)
        },
        onHideListEvent: function() {
          let containerList = $('#locations-autocomplete').next('.easy-autocomplete-container').find('ul')
          if ($(containerList).children('li').length <= 0 ) {
            $(containerList).html('<li>Lokasi tidak ditemukan.</li>').show()
          }
        }
      }
    });
  }
}
